"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var basedecoder_js_1 = __importDefault(require("./basedecoder.js"));
/**
 * class WebImageDecoder
 *
 * This decoder uses the browsers image decoding facilities to read image
 * formats like WebP when supported.
 */


var WebImageDecoder = /*#__PURE__*/function (_basedecoder_js_1$def) {
  (0, _inherits2.default)(WebImageDecoder, _basedecoder_js_1$def);

  var _super = _createSuper(WebImageDecoder);

  function WebImageDecoder() {
    var _this;

    (0, _classCallCheck2.default)(this, WebImageDecoder);
    _this = _super.call(this);

    if (typeof createImageBitmap === 'undefined') {
      throw new Error('Cannot decode WebImage as `createImageBitmap` is not available');
    } else if (typeof document === 'undefined' && typeof OffscreenCanvas === 'undefined') {
      throw new Error('Cannot decode WebImage as neither `document` nor `OffscreenCanvas` is not available');
    }

    return _this;
  }

  (0, _createClass2.default)(WebImageDecoder, [{
    key: "decode",
    value: function () {
      var _decode = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fileDirectory, buffer) {
        var blob, imageBitmap, canvas, ctx;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                blob = new Blob([buffer]);
                _context.next = 3;
                return createImageBitmap(blob);

              case 3:
                imageBitmap = _context.sent;

                if (typeof document !== 'undefined') {
                  canvas = document.createElement('canvas');
                  canvas.width = imageBitmap.width;
                  canvas.height = imageBitmap.height;
                } else {
                  canvas = new OffscreenCanvas(imageBitmap.width, imageBitmap.height);
                }

                ctx = canvas.getContext('2d');
                ctx.drawImage(imageBitmap, 0, 0); // TODO: check how many samples per pixel we have, and return RGB/RGBA accordingly
                // it seems like GDAL always encodes via RGBA which does not require a translation

                return _context.abrupt("return", ctx.getImageData(0, 0, imageBitmap.width, imageBitmap.height).data.buffer);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function decode(_x, _x2) {
        return _decode.apply(this, arguments);
      }

      return decode;
    }()
  }]);
  return WebImageDecoder;
}(basedecoder_js_1.default);

exports.default = WebImageDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTtBQUVBOzs7Ozs7OztJQU1xQkEsZTs7Ozs7RUFDbkI7SUFBQTs7SUFBQTtJQUNFOztJQUNBLElBQUksT0FBT0MsaUJBQVAsS0FBNkIsV0FBakMsRUFBOEM7TUFDNUMsTUFBTSxJQUFJQyxLQUFKLENBQVUsZ0VBQVYsQ0FBTjtJQUNELENBRkQsTUFFTyxJQUFJLE9BQU9DLFFBQVAsS0FBb0IsV0FBcEIsSUFBbUMsT0FBT0MsZUFBUCxLQUEyQixXQUFsRSxFQUErRTtNQUNwRixNQUFNLElBQUlGLEtBQUosQ0FBVSxxRkFBVixDQUFOO0lBQ0Q7O0lBTkg7RUFPQzs7Ozs7NEZBRUQsaUJBQWFHLGFBQWIsRUFBNEJDLE1BQTVCO1FBQUE7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFDUUMsSUFEUixHQUNlLElBQUlDLElBQUosQ0FBUyxDQUFDRixNQUFELENBQVQsQ0FEZjtnQkFBQTtnQkFBQSxPQUU0QkwsaUJBQWlCLENBQUNNLElBQUQsQ0FGN0M7O2NBQUE7Z0JBRVFFLFdBRlI7O2dCQUtFLElBQUksT0FBT04sUUFBUCxLQUFvQixXQUF4QixFQUFxQztrQkFDbkNPLE1BQU0sR0FBR1AsUUFBUSxDQUFDUSxhQUFULENBQXVCLFFBQXZCLENBQVQ7a0JBQ0FELE1BQU0sQ0FBQ0UsS0FBUCxHQUFlSCxXQUFXLENBQUNHLEtBQTNCO2tCQUNBRixNQUFNLENBQUNHLE1BQVAsR0FBZ0JKLFdBQVcsQ0FBQ0ksTUFBNUI7Z0JBQ0QsQ0FKRCxNQUlPO2tCQUNMSCxNQUFNLEdBQUcsSUFBSU4sZUFBSixDQUFvQkssV0FBVyxDQUFDRyxLQUFoQyxFQUF1Q0gsV0FBVyxDQUFDSSxNQUFuRCxDQUFUO2dCQUNEOztnQkFFS0MsR0FiUixHQWFjSixNQUFNLENBQUNLLFVBQVAsQ0FBa0IsSUFBbEIsQ0FiZDtnQkFjRUQsR0FBRyxDQUFDRSxTQUFKLENBQWNQLFdBQWQsRUFBMkIsQ0FBM0IsRUFBOEIsQ0FBOUIsRUFkRixDQWdCRTtnQkFDQTs7Z0JBakJGLGlDQW1CU0ssR0FBRyxDQUFDRyxZQUFKLENBQWlCLENBQWpCLEVBQW9CLENBQXBCLEVBQXVCUixXQUFXLENBQUNHLEtBQW5DLEVBQTBDSCxXQUFXLENBQUNJLE1BQXRELEVBQThESyxJQUE5RCxDQUFtRVosTUFuQjVFOztjQUFBO2NBQUE7Z0JBQUE7WUFBQTtVQUFBO1FBQUE7TUFBQSxDOzs7Ozs7Ozs7O0VBVjJDYSx3Qjs7QUFBN0NDIiwibmFtZXMiOlsiV2ViSW1hZ2VEZWNvZGVyIiwiY3JlYXRlSW1hZ2VCaXRtYXAiLCJFcnJvciIsImRvY3VtZW50IiwiT2Zmc2NyZWVuQ2FudmFzIiwiZmlsZURpcmVjdG9yeSIsImJ1ZmZlciIsImJsb2IiLCJCbG9iIiwiaW1hZ2VCaXRtYXAiLCJjYW52YXMiLCJjcmVhdGVFbGVtZW50Iiwid2lkdGgiLCJoZWlnaHQiLCJjdHgiLCJnZXRDb250ZXh0IiwiZHJhd0ltYWdlIiwiZ2V0SW1hZ2VEYXRhIiwiZGF0YSIsImJhc2VkZWNvZGVyX2pzXzEiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL2NvbXByZXNzaW9uL3dlYmltYWdlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19